const config = {
    pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
    siteTitle: 'Michel Comin', // Navigation and Site Title
    siteTitleAlt: 'Michel Comin - Portfolio', // Alternative Site title for SEO
    siteUrl: 'http://michel.com.es/', // Domain of your site. No trailing slash!
    siteLanguage: 'en', // Language Tag on <html> element
    siteLogo: '/logos/logo-1024.png', // Used for SEO and manifest
    siteDescription: 'Michel Portfolio',
    userTwitter: 'mcx_sic', // Twitter Username
    // og: Meta Tags
    ogSiteName: 'michel-comin', // Facebook Site Name
    googleAnalyticsID: 'UA-12345689-1',
    // Date format used in your project header
    // More information here: https://date-fns.org/v1.29.0/docs/format
    dateFormat: 'DD.MM.YYYY',
    // Manifest and Progress color
    themeColor: '#3498DB',
    backgroundColor: '#2b2e3c',
};

export default config;



// WEBPACK FOOTER //
// ./src/config/site-config.js